import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageTitle from "../layouts/PageTitle";
import { Formik } from "formik";
import * as Yup from "yup";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";

const LeaveSchema = Yup.object().shape({
  Name: Yup.string().required("Leave name is required"),
  F_FirmMaster: Yup.number().min(1, "Firm is required").required("Firm is required"),
  F_YearMaster: Yup.number().required("Year is required"),
  MaxLimit: Yup.number().required("Max limit is required"),
  LeavePayableLimit: Yup.number().required("Leave payable limit is required"),
  MaxContinousLeave: Yup.number().required("Max continuous leave is required"),
  DaysToCalculateLeaveWithWages: Yup.number().required("Days to calculate leave with wages is required"),
});

const AddEdit_LeaveMaster = () => {
  // Dashboard se selected firm pick karo (same as Payroll, EmployeeMaster etc.)
  const selectedFirm = (() => { try { return JSON.parse(localStorage.getItem("selectedFirm") || "null"); } catch { return null; } })();
  const firmId = selectedFirm?.Id || 0;

  const [state, setState] = useState({
    id: 0,
    formData: {
      F_FirmMaster: firmId,
      F_YearMaster: "",
      Name: "",
      IsYearCarryforward: false,
      MaxLimit: "",
      LeavePayableLimit: "",
      MaxContinousLeave: "",
      DaysToCalculateLeaveWithWages: "",
    },
    FirmMaster: [],
    YearMaster: [],
    isProgress: false,
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const API_URL_SAVE = "LeaveMaster/0/token";
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/LeaveMaster/Id`;

  useEffect(() => {
    Fn_FillListData(dispatch, setState, "FirmMaster", `${API_WEB_URLS.MASTER}/0/token/FirmMaster/Id/0`);
    Fn_FillListData(dispatch, setState, "YearMaster", `${API_WEB_URLS.MASTER}/0/token/YearMaster/Id/0`);

    const Id = (location.state && location.state.Id) || 0;
    if (Id > 0) {
      setState((prev) => ({ ...prev, id: Id }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    } else {
      // New record: pre-fill firm from dashboard
      setState((prev) => ({
        ...prev,
        formData: { ...prev.formData, F_FirmMaster: firmId },
      }));
    }
  }, [dispatch, location.state]);

  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();
      formData.append("F_FirmMaster", values.F_FirmMaster);
      formData.append("F_YearMaster", values.F_YearMaster);
      formData.append("Name", values.Name);
      formData.append("IsYearCarryforward", values.IsYearCarryforward ? true : false);
      formData.append("MaxLimit", values.MaxLimit);
      formData.append("LeavePayableLimit", values.LeavePayableLimit);
      formData.append("MaxContinousLeave", values.MaxContinousLeave);
      formData.append("DaysToCalculateLeaveWithWages", values.DaysToCalculateLeaveWithWages);

      Fn_AddEditData(
        dispatch,
        setState,
        { arguList: { id: state.id, formData } },
        API_URL_SAVE,
        true,
        "memberid",
        navigate,
        "/LeaveMaster"
      );
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while submitting the form. Please try again.");
    }
  };

  return (
    <Fragment>
      <PageTitle activeMenu="Masters" motherMenu="Masters" pageContent="Leave Master" />

      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap" style={{ gap: "10px" }}>
              <h4 className="card-title mb-0">Leave Master</h4>
              {selectedFirm?.Name ? (
                <span style={{
                  background: "#1a7f4b",
                  color: "#fff",
                  padding: "4px 14px",
                  borderRadius: "20px",
                  fontSize: "13px",
                  fontWeight: 600,
                  letterSpacing: "0.3px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}>
                  <i className="fa fa-building" style={{ fontSize: "11px" }} />
                  {selectedFirm.Name}
                </span>
              ) : (
                <span style={{
                  background: "#dc3545",
                  color: "#fff",
                  padding: "4px 14px",
                  borderRadius: "20px",
                  fontSize: "12px",
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}>
                  <i className="fa fa-exclamation-triangle" style={{ fontSize: "11px" }} />
                  Dashboard se Firm Select karo
                </span>
              )}
            </div>
            <div className="card-body">
              <div className="basic-form">
                <Formik
                  initialValues={state.formData}
                  enableReinitialize
                  validationSchema={LeaveSchema}
                  onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                      handleSubmit(values);
                      setSubmitting(false);
                    }, 400);
                  }}
                >
                  {({ values, errors, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        {/* F_FirmMaster hidden - auto filled from dashboard */}
                        <input type="hidden" name="F_FirmMaster" value={values.F_FirmMaster} onChange={handleChange} />

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Year *</label>
                          <select
                            className="form-control"
                            name="F_YearMaster"
                            value={values.F_YearMaster}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="">-- Select Year --</option>
                            {state.YearMaster.map((y) => <option key={y.Id} value={y.Id}>{y.Name}</option>)}
                          </select>
                          {errors.F_YearMaster && <div className="text-danger fs-12">{errors.F_YearMaster}</div>}
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Leave Name *</label>
                          <input
                            type="text"
                            className="form-control"
                            name="Name"
                            value={values.Name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.Name && <div className="text-danger fs-12">{errors.Name}</div>}
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Max Limit *</label>
                          <input
                            type="number"
                            className="form-control"
                            name="MaxLimit"
                            value={values.MaxLimit}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.MaxLimit && <div className="text-danger fs-12">{errors.MaxLimit}</div>}
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Leave Payable Limit *</label>
                          <input
                            type="number"
                            className="form-control"
                            name="LeavePayableLimit"
                            value={values.LeavePayableLimit}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.LeavePayableLimit && <div className="text-danger fs-12">{errors.LeavePayableLimit}</div>}
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Max Continuous Leave *</label>
                          <input
                            type="number"
                            className="form-control"
                            name="MaxContinousLeave"
                            value={values.MaxContinousLeave}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.MaxContinousLeave && <div className="text-danger fs-12">{errors.MaxContinousLeave}</div>}
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Days To Calculate Leave With Wages *</label>
                          <input
                            type="number"
                            className="form-control"
                            name="DaysToCalculateLeaveWithWages"
                            value={values.DaysToCalculateLeaveWithWages}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.DaysToCalculateLeaveWithWages && <div className="text-danger fs-12">{errors.DaysToCalculateLeaveWithWages}</div>}
                        </div>

                        <div className="col-md-6 mb-3 d-flex align-items-center mt-2">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="IsYearCarryforward"
                              name="IsYearCarryforward"
                              checked={!!values.IsYearCarryforward}
                              onChange={(e) => setFieldValue("IsYearCarryforward", e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="IsYearCarryforward">
                              Year Carryforward
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="mt-3">
                        <button type="submit" className="btn btn-primary me-2" disabled={isSubmitting}>
                          {isSubmitting ? "Saving..." : "Save"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger light"
                          onClick={() => navigate("/LeaveMaster")}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddEdit_LeaveMaster;
